import { Alignment, Border, Borders, Cell, FillPattern, Font } from 'exceljs';

const THEME = {
  primaryTeal: 'FF17A2B8',
  lightTeal: 'FFEBFCFF',
  darkGrey: 'FF434343',
  grey: 'FF666666',
  lightGrey: 'FFB7B7B7',
  whiteGrey: 'FFD9D9D9',
  white: 'FFFFFFFF',
  lightOrange: 'FF9900',
  veryLightOrange: 'F2CDA2'
};

const FONT_NAME = 'Arial';

const STYLES = {
  middleCenterWrappedAlignment: {
    vertical: 'middle',
    horizontal: 'center',
    wrapText: true
  } as Partial<Alignment>,
  middleRightWrappedAlignment: {
    vertical: 'middle',
    horizontal: 'right',
    wrapText: true
  } as Partial<Alignment>,
  middleLeftWrappedAlignment: {
    vertical: 'middle',
    horizontal: 'left',
    wrapText: true
  } as Partial<Alignment>,
  primaryTealFill: {
    type: 'pattern',
    pattern: 'solid',
    fgColor: { argb: THEME.primaryTeal },
    bgColor: { argb: '00000000' }
  } as FillPattern,
  lightTealFill: {
    type: 'pattern',
    pattern: 'solid',
    fgColor: { argb: THEME.lightTeal },
    bgColor: { argb: '00000000' }
  } as FillPattern,
  primaryTealBorderTop: {
    top: {
      color: {
        argb: THEME.primaryTeal
      },
      style: 'medium'
    } as Partial<Border>
  } as Partial<Borders>,
  primaryTealBorderBottom: {
    bottom: {
      color: {
        argb: THEME.primaryTeal
      },
      style: 'medium'
    } as Partial<Border>
  } as Partial<Borders>,
  primaryTealBorder: {
    color: {
      argb: THEME.primaryTeal
    },
    style: 'medium'
  } as Partial<Border>,
  greyBorder: {
    color: {
      argb: THEME.whiteGrey
    },
    style: 'medium'
  } as Border,
  h1Font: {
    name: FONT_NAME,
    size: 24,
    bold: true,
    color: {
      argb: THEME.primaryTeal
    }
  } as Partial<Font>,
  h2Font: {
    name: FONT_NAME,
    size: 16,
    bold: true,
    color: {
      argb: THEME.darkGrey
    }
  } as Partial<Font>,
  h3Font: {
    name: FONT_NAME,
    size: 12,
    bold: true,
    color: {
      argb: THEME.grey
    }
  } as Partial<Font>,
  whiteBoldFont: {
    name: FONT_NAME,
    size: 10,
    bold: true,
    color: {
      argb: THEME.white
    }
  } as Partial<Font>,
  boldFont: {
    name: FONT_NAME,
    size: 10,
    bold: true,
    color: {
      argb: THEME.darkGrey
    }
  } as Partial<Font>,
  italicFont: {
    name: FONT_NAME,
    size: 10,
    italic: true,
    color: {
      argb: THEME.darkGrey
    }
  } as Partial<Font>,
  normalFont: {
    name: FONT_NAME,
    size: 10,
    color: {
      argb: THEME.darkGrey
    }
  } as Partial<Font>,
  naFont: {
    name: FONT_NAME,
    size: 10,
    color: {
      argb: THEME.lightGrey
    }
  } as Partial<Font>,
  lightOrangeFill: {
    type: 'pattern',
    pattern: 'solid',
    fgColor: { argb: THEME.lightOrange },
    bgColor: { argb: '00000000' }
  } as FillPattern,
  veryLightOrangeFill: {
    type: 'pattern',
    pattern: 'solid',
    fgColor: { argb: THEME.veryLightOrange },
    bgColor: { argb: '00000000' }
  } as FillPattern,
  thinGreyBorder: {
    color: {
      argb: THEME.whiteGrey
    },
    style: 'thin'
  } as Border,
  thinPrimaryTealBorderTop: {
    top: {
      color: {
        argb: THEME.primaryTeal
      },
      style: 'thin'
    } as Partial<Border>
  } as Partial<Borders>
};

const NA = 'n/a';

interface Style {
  fill?: FillPattern;
  border?: Partial<Borders>;
  font?: Partial<Font>;
  alignment?: Partial<Alignment>;
}

type CallbackFn = (cell: Cell, index: number) => void;

const EMPTY = '';

export { THEME, FONT_NAME, STYLES, NA, EMPTY, Style, CallbackFn };
